module.exports = __webpack_public_path__ + "static/elia-logo-4e4fee54fe3fc0570ddce801eca44237.png";